import { Component } from '@angular/core';
import { BaseSelectSearch as MainBase } from '../../form-kit/select-search/base/base-select-search.component';
@Component({
    template: ``,
    standalone: false
})
export abstract class BaseSelectSearch extends MainBase { }
